import { createAction, props } from '@ngrx/store';
import { CalculatedStreamDTO, KTLFGDOverrideRecordDTO, UpdateOxidizersAndCNSDTO } from 'src/app/web-api-client';

export const getDailyFuelGas = createAction(
  '[KTL] Get Daily Fuel Gas',
  props<{ startTime: Date}>()
);
export const getDailyFuelGasSuccess = createAction(
  '[KTL] Get Daily Fuel Gas Success',
  props<{ data: CalculatedStreamDTO[] }>()
);
export const getDailyFuelGasFailure = createAction(
  '[KTL] Get Daily Fuel Gas Failure',
  props<{ message: string }>()
);

export const getDailyUpdatedFuelGas = createAction(
  '[KTL] Get Daily Updated Fuel Gas',
  props<{ isDaily: boolean }>()
);
export const getDailyUpdatedFuelGasSuccess = createAction(
  '[KTL] Get Daily Updated Fuel Gas Success',
  props<{ data: Date }>()
);
export const getDailyUpdatedFuelGasFailure = createAction(
  '[KTL] Get Daily Updated Fuel Gas Failure',
  props<{ message: string }>()
);

export const UpdateOxidizersAndCNS = createAction(
  '[KTL] Update Oxidizers And CNS',
  props<{date: Date; props: UpdateOxidizersAndCNSDTO[];}>()
);
export const UpdateOxidizersAndCNSSuccess = createAction(
  '[KTL] Update Oxidizers And CNS Success',
  props<any>()
);
export const UpdateOxidizersAndCNSFailure = createAction(
  '[KTL] Update Oxidizers And CNS Failure',
  props<{ message: string }>()
);

export const AddOverrideManualRecords = createAction(
  '[KTL] Add Override Manual Records',
  props<{date: Date; props: KTLFGDOverrideRecordDTO[];}>()
);
export const AddOverrideManualRecordsSuccess = createAction(
  '[KTL] Add Override Manual Records Success',
  props<any>()
);
export const AddOverrideManualRecordsFailure = createAction(
  '[KTL] Add Override Manual Records Failure',
  props<{ message: string }>()
);

export const getIsDailyRecordExist = createAction(
  '[KTL] Get Is Daily Record Exist',
  props<{ startTime: Date, isDailyReport: boolean }>()
);
export const getIsDailyRecordExistSuccess = createAction(
  '[KTL] Get Is Daily Record Exist Success',
  props<{ isDailyRecordExistdata: boolean }>()
);
export const getIsDailyRecordExistFailure = createAction(
  '[KTL] Get Is Daily Record Exist Failure',
  props<{ message: string }>()
);

export const DeleteOverrideRecord = createAction(
  '[KTL] Override Record Delete',
  props<{ streamId: number; startTime: Date; isDailyReport: boolean}>()
);
export const DeleteOverrideRecordSuccess = createAction(
  '[KTL] Override Record Delete Success',
  props<any>()
);
export const DeleteOverrideRecordFailure = createAction(
  '[KTL] Override Record Delete Failure',
  props<{ message: string }>()
);

export const RefreshRecords = createAction(
  '[KTL] Refresh Records',
  props<{ date: Date }>()
);
export const RefreshRecordsSuccess = createAction(
  '[KTL] Refresh Records Success',
  props<any>()
);
export const RefreshRecordsFailure = createAction(
  '[KTL] Refresh Records Failure',
  props<{ message: string }>()
);